import React from 'react';
import { Box, Flex, Input } from '@spothero/ui';
import { LockFilled as IconLock } from '@spothero/icons';
import PaymentMethodsIcons from 'common/payment-methods-icons';
import StripeCreditCardElement from 'pages/checkout/components/user-payment-picker/stripe-credit-card-element/StripeCreditCardElement.jsx';
import { Controller } from 'react-hook-form';
import { NAME_FIELD } from './index';
const AddCard = ({ control, errors, containerStyles, }) => {
    return (<Box borderTopWidth="1px" borderTopColor="gray.200" {...containerStyles}>
            <Flex justifyContent="space-between" borderColor="gray.medium" borderBottomWidth="1px" backgroundColor="gray.light" paddingX={4} paddingY={3}>
                <Box>
                    <PaymentMethodsIcons showLesserUsed={false} showMoreText={false} alignment="flex-start"/>
                </Box>
                <Flex direction="row" align="center">
                    <Box as="span" position="relative" marginRight={1.5} color="gray.400" height="0.75rem" display="flex">
                        <IconLock width="0.75rem" height="0.75rem"/>
                    </Box>
                    <Box as="small" fontSize="xs" color="black" height="1rem">
                        Secure and encrypted
                    </Box>
                </Flex>
            </Flex>
            <Flex padding={4} flexDirection="column">
                <Box marginBottom={3.5} width={{
            base: '100%',
            tablet: '80%',
        }}>
                    <StripeCreditCardElement />
                </Box>
                <Box marginBottom={3.5} width={{
            base: '100%',
            tablet: '80%',
        }}>
                    <Controller name={NAME_FIELD} control={control} render={({ field: inputField }) => (<Input id={NAME_FIELD} width="100%" label="Name on Card" fontFamily="body" isInvalid={errors[NAME_FIELD]} errorMessage="Please enter the Cardholder Name" isRequired {...inputField}/>)}/>
                </Box>
            </Flex>
        </Box>);
};
export default AddCard;
